import React from 'react';
import PressKit from '../presskit/PressKit';

const PressKitPage = () => {
    return (
        <div>
            <PressKit />
        </div>
    );
};

export default PressKitPage;
